module.exports = __webpack_public_path__ + "img/hexagon_1.eca0efe9.png";